import axios from 'axios';
import { getBaseUrlAnalista, ensureProtocol } from '../config/backend';

const REFRESH_MARGIN_MS = 2 * 60 * 1000;
let refreshTimer = null;
let refreshPromise = null;

const bare = typeof axios.create === 'function' ? axios.create({ timeout: 15000 }) : axios;

export function baseUrlAnalista() {
  return getBaseUrlAnalista() || ensureProtocol(localStorage.getItem('ipBackend2') || '');
}

export function getAuthHeader() {
  const t = localStorage.getItem('token');
  if (!t || !t.trim()) return {};
  return { Authorization: t.startsWith('Bearer ') ? t : 'Bearer ' + t };
}

export function decodeJwt(token) {
  try {
    const raw = token && token.startsWith('Bearer ') ? token.slice(7) : token;
    if (!raw || raw.split('.').length < 2) return null;
    const base64 = raw.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    const json = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(json);
  } catch (_) {
    return null;
  }
}

export function msUntilExpiry(token) {
  const payload = decodeJwt(token || localStorage.getItem('token') || '');
  if (!payload || !payload.exp) return null;
  return payload.exp * 1000 - Date.now();
}

export function persistTokens(data) {
  if (!data) return;
  if (data.token) {
    localStorage.setItem('token', data.token.startsWith('Bearer ') ? data.token : 'Bearer ' + data.token);
  }
  if (data.empresa_id != null) localStorage.setItem('empresa_id', data.empresa_id);
  if (data.empresa_nome != null) localStorage.setItem('empresa_nome', data.empresa_nome);
  if (data.isSoftbridge != null) localStorage.setItem('isSoftbridge', data.isSoftbridge ? 'S' : 'N');
  if (data.ia_habilitada != null) localStorage.setItem('ia_habilitada', String(data.ia_habilitada));
}

export function limparSessao() {
  localStorage.setItem('token', '');
  localStorage.setItem('logado', 'N');
  localStorage.setItem('codUsu', 0);
  if (refreshTimer) {
    clearTimeout(refreshTimer);
    refreshTimer = null;
  }
}

export function refreshAccessToken() {
  if (refreshPromise) return refreshPromise;
  const base = baseUrlAnalista();
  const token = localStorage.getItem('token');
  if (!base || !token || !token.trim()) return Promise.resolve(null);

  const authHeader = token.startsWith('Bearer ') ? token : 'Bearer ' + token;

  refreshPromise = bare
    .post(base + '/token/refresh', {}, { headers: { Authorization: authHeader } })
    .then((res) => {
      const data = res?.data;
      if (data && data.token) {
        persistTokens(data);
        agendarRenovacao();
        return localStorage.getItem('token') || null;
      }
      return null;
    })
    .catch(() => null)
    .finally(() => {
      refreshPromise = null;
    });

  return refreshPromise;
}

export function agendarRenovacao() {
  if (refreshTimer) {
    clearTimeout(refreshTimer);
    refreshTimer = null;
  }
  const token = localStorage.getItem('token');
  if (!token || !token.trim()) return;

  const ms = msUntilExpiry(token);
  if (ms == null) return;
  const delay = Math.max(5000, ms - REFRESH_MARGIN_MS);
  refreshTimer = setTimeout(() => {
    refreshAccessToken();
  }, delay);
}

export function refreshSeNecessario() {
  const token = localStorage.getItem('token');
  if (!token || !token.trim()) return Promise.resolve(null);
  const ms = msUntilExpiry(token);
  if (ms == null) return Promise.resolve(token);
  if (ms <= REFRESH_MARGIN_MS) {
    return refreshAccessToken();
  }
  return Promise.resolve(token);
}

let visibilityHooked = false;

export function iniciarGestaoToken() {
  agendarRenovacao();
  if (!visibilityHooked && typeof document !== 'undefined') {
    visibilityHooked = true;
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        refreshSeNecessario();
      }
    });
  }
}
